import { TextField, styled } from '@mui/material'

export const StyledTextField = styled(TextField)(() => ({
  margin: '5px 0px',
}))
